<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div class="sl-card">

        <!-- title -->
        <div class="sl-card__title">
            {{ $t('card.return_price.title') }}
        </div>

        <!-- Return Price -->
        <div class="sl-card-details__price-line">
            <!-- Return Policy Label or Price Message -->
            <div v-if="!oReturn.price_information?.message" class="sl-card-details__price-line-label">
                {{ oReturn.return_policy.label }}
            </div>
            <div v-else class="sl-card-details__price-line-label !text-red-600">
                {{ oReturn.price_information.message }}
            </div>
            <!-- Return Price (calculated by Policy) -->
            <div class="sl-card-details__price-line-value" :class="{ 'blur': !isPriceVisible }">
                {{ oReturn.currency_code }}&nbsp;{{ $f(oReturn.price, 'decimal:2') }}
            </div>
        </div>

        <!-- Return Special Price -->
        <div v-if="oReturn.special_price" class="sl-card-details__price-line">
            <div class="sl-card-details__price-line-label">
                {{ t('return_table.details.special_price.label') }}
            </div>

            <div class="sl-card-details__price-line-value" :class="{ 'blur': !isPriceVisible }">
                {{ oReturn.currency_code }}&nbsp;{{ $f(oReturn.special_price, 'decimal:2') }}
            </div>
        </div>

    </div>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

export default
{
    name: 'ReturnPriceCard',

    props:
    {
        oReturn:
        {
            type:     Object,
            required: true,
        },
    },

    computed:
    {
        isPriceVisible()
        {
            return this.$store.state.pricesVisible;
        },
    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>



</style>
